var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('all-transactions-list',{ref:"alltransactionList",attrs:{"payment-gateway":_vm.paymentGateway,"show-global":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }